import { cn } from '../../lib/utils';

const MAP: Record<string, string> = {
  approved: 'badge-live',
  active: 'badge-live',
  paid: 'badge-live',
  pending: 'badge-paused',
  paused: 'badge-paused',
  reversed: 'badge-archived',
  archived: 'badge-archived',
  disabled: 'badge-archived',
  rejected: 'badge-error',
  // Defensive alias only: REVERSED visually maps to badge-archived (above); rejected maps to badge-error.
  reversed_: 'badge-error',
};

export function StatusBadge({ status, className }: { status: string; className?: string }) {
  const cls = MAP[status.toLowerCase()] ?? 'badge';
  return <span className={cn(cls, className)}>{status.toUpperCase()}</span>;
}
